/** Created by azhou on 2019/3/8.*/
<template>
    <div class="blank_space">
      <el-alert :title="TitleMsg" type="success" :class="BasicInfo.edit_status==1&&'red'" :closable="false" center v-if="!isGroup"/>
      <!-- 企业填写信息 -->
      <div class="TravelAgency" v-if="reviewStatus==0||isGroup">
            <div class="certification mt-4" v-if="!isGroup&&storeInfo.storeId>0">
                <div class="certification-title">认证通过后会成为认证企业</div>
                <el-button @click="submitForm" class="w-20 " type="primary" plain>提交企业认证</el-button>
            </div>
          <div class="mt-4 mb-3">
            <left-text-border class="mb-3"
                leftText="采购商名称"
                v-model="BasicInfo.title"
                :placeholder="BasicInfo.title"
                required
                inputId="inputTitle"
                />
            <select-city class="mb-3"
              leftText="省市区"
              required
              @getCityInfo="getCityInfo"
              :provinceId="BasicInfo.province*1"
              :cityId="BasicInfo.city*1"
              :districtId="BasicInfo.district*1"
            />
            <left-text-border class="mb-3"
              leftText="详细地址"
              placeholder="请输入详细地址"
              required
              v-model="BasicInfo.address"
            />
            <left-text-border class="mb-3"
                    leftText="办公电话"
                    v-model="BasicInfo.travel_tel"
                    placeholder="例如：0571-123456"
            required/>
          </div>
            <el-button @click="reVerify" class="mt-4 w-25 btn-login">保存信息</el-button>
            <!-- <el-button @click="reVerify" class="mt-4 w-25" style="display: block; margin: 0 auto;">申请加入企业</el-button> -->
        </div>
        <div class="TravelAgency mt-100" v-if="reviewStatus==1&&!isGroup">
            <div class="login-header">
                <img src="/images/public/logo.png" height="100" />
                <div v-if="salesAssociationLists.total>0">认证企业：{{salesAssociationLists.lists[0].title}}</div>
                <el-button  class="w-20 btn-login mt-4"  >已关联该企业</el-button>
            </div>
        </div>
        <!-- 企业认证审核信息 -->
        <div class="TravelAgency mt-4" v-if="reviewStatus==2">
                <left-text-border class="mb-3"
                    leftText="采购商名称"
                    v-model="BasicInfo.title"
                    :placeholder="BasicInfo.title"
                    disabled
                    inputId="inputTitle"
                    required
                />
                <left-text-border class="mb-3"
                    leftText="省市区"
                    disabled
                    v-model="pcd"
                    required
                />
                <left-text-border class="mb-3"
                    leftText="详细地址"
                    placeholder="请输入详细地址"
                    disabled
                    v-model="BasicInfo.address"
                    required
                />
                <left-text-border class="mb-3"
                    leftText="办公电话"
                    v-model="BasicInfo.travel_tel"
                    disabled
                    placeholder="例如：0571-123456"
                    required
                />
                <el-button  class="mt-4 w-25" type="primary" plain>正在审核中~</el-button>
        </div>
      <el-dialog title="提交信息" :visible.sync="showConfirmPanel" width="480px" center id="loadConfirm">
        <Verify-Info-Text :priceArrs='Informationtext'/>
        <div slot="footer">
          <el-button size="small" type="primary" @click="showConfirmPanel = false">返回</el-button>
        </div>
      </el-dialog>
    </div>
</template>

<script>
  import { mapState,mapGetters,mapActions } from 'vuex'
  import VerifyInfoText from './VerifyInfoText.vue'
  export default {
    name: 'VerifyInfo',
    components: {VerifyInfoText},
    computed: {
      ...mapState(['userLoginMessage',"Informationtext","salesAssociationLists","newMessageInform"]),
      ...mapGetters(['storeInfo','isGroup','userInfo',]),
      TitleMsg() {
        if (this.reviewStatus==0) return '企业信息保存后，可提企业交认，证通过后自动关联企业信息'
        if (this.reviewStatus==1) return '企业认证已通过、正在关联该企业'
        if (this.reviewStatus==2) return '企业认证信息已提交，请耐心等待审核...'
      },
    },
    data() {
      return {
        BasicInfo:{
            title:'',
            province:'',
            city:'',
            district:'',
            address:'',
            travel_tel:'',
        },
        showConfirmPanel: false,
        reviewStatus:-1,                   //审核状态 
        pcd:'',
      }
    },
    watch: {
      //收到消息推送刷新信息
      newMessageInform (newVal) {
        if(newVal.type==41){
            this.initStoreInfo()
        }
      },
    },
    created () {
      this.initStoreInfo()
    },
    methods:{
      ...mapActions(['POST_BuyEnterpriseSave',,'POST_TravelInfo','POST_BuyEnterpriseSubmit',"POST_UnionRecordSaleList","POST_RegBuyPersonalFill","updateInfo",'POST_CheckUnionApply']),
      initStoreInfo () {
        if (this.storeInfo.storeId>0) {
          this.POST_TravelInfo({
            data: {
              store_id: this.storeInfo.storeId,
            },
            successFun: (res) => {
                //审核通过调取关联列表
                if(res.info.verify == 1&&!this.isGroup){
                     this.POST_UnionRecordSaleList({data:{},successFun:()=>{this.loading = false;}});
                }
                //审核状态
                if(res.info.verify == 2){
                    this.pcd = res.info.province_name + '省,' + res.info.city_name + '市,' + res.info.district_name;
                } 
                this.reviewStatus=res.info.verify||0;
                this.BasicInfo = {...res.info};
            }
          })
        }else{
            this.reviewStatus=0;
            this.BasicInfo = {...this.userLoginMessage.info_store_arr};
        }
      },
    /*获取省市区id和name*/
      getCityInfo (info) {
        for (let key in info) {
          this.BasicInfo[key] = info[key];
        }
      },
      /*验证门店基本信息填写是否正确*/
      validateForm () {
        let i = this.BasicInfo
        if (!i.title) return { code: false, msg: '请填写采购商名称' }
        if (!i.province || !i.city || !i.district) return { code: false, msg: '请选择省市区' }
        if (!i.address) return { code: false, msg: '请填写详细地址' }
        if (!this.$GFUN.isFixTel(i.travel_tel)) return { code: false, msg: '请填写正确的办公电话' }
        return { code: true, msg: '表单验证通过' }
      },
        /*提交企业认证*/
      async submitForm () {
        let result = this.validateForm();
         let _this = this;
        if (result.code) {
          this._confirm('证信息提交申请期间，不可再次修改信息，待通过后自动绑定企业信息。确认提交么？',async () => {
            this.POST_BuyEnterpriseSubmit({
              data: this.BasicInfo,
              successFun: () => {
                //更新门店信息
               _this.reviewStatus=2;
              }})
          })
        } else this._alert(result.msg,null,'error');
      },
        /*保存门店基本信息*/
      reVerify() {
        let result = this.validateForm();
        let _this = this;
        if (result.code) {
          this._confirm('确定保存企业信息么？',async () => {
            let POST=this.POST_BuyEnterpriseSave;
            POST({
              data: this.BasicInfo,
              successFun: async () => {
                //更新门店信息
                _this.initStoreInfo();
              }})
        })
        } else this._alert(result.msg,null,'error');
      }
    }
  }
</script>
<style scoped>
.lies{
  margin-top: 10px;
}
.lies p{
  margin-top: 10px;
}
.red{
  color: red;
}
.list-text{
  color: #999;
}
.TravelAgency{
    width: 1000px;
    margin: 0 auto;
}
.certification{
    display: flex;
    justify-content: flex-end;
}
.certification-title{
    display: flex;
    justify-content: center;
    flex-direction: column;
    margin-right: 20px;
    color: #999;
}
.mt-100{
    margin-top: 140px;
}
</style>
